(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["combo-looks"] && !Shopify.designMode) return;
  try {
    
/* Add both shades of a look in one call, then go to the bag — the same ending the free builder on this
   page already uses, so the two routes do not behave differently. */
document.querySelectorAll('[data-combo-looks]').forEach(root => {
 const status = root.querySelector('[data-look-status]');
 root.addEventListener('click', async event => {
  const button = event.target.closest('[data-look-add]');
  if (!button) return;
  const items = button.dataset.lookAdd.split(',').map(id => ({ id: Number(id.trim()), quantity: 1 }));
  if (items.some(item => !item.id)) return;
  button.disabled = true;
  button.classList.add('is-loading');
  if (status) status.textContent = '';
  try {
   const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items })
   });
   const body = await res.json();
   if (!res.ok) throw new Error(body.description || root.dataset.error);
   window.location.assign(root.dataset.cartUrl);
  } catch (err) {
   if (status) status.textContent = err.message || root.dataset.error;
   button.disabled = false;
   button.classList.remove('is-loading');
  }
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ethos-manifesto"] && !Shopify.designMode) return;
  try {
    
/* Belief counter: shows which numbered belief is under the middle of the screen. */
document.querySelectorAll('[data-ethos]').forEach(root => {
 const counter = root.querySelector('[data-ethos-counter]');
 const current = root.querySelector('[data-ethos-current]');
 const beliefs = [...root.querySelectorAll('[data-ethos-belief]')];
 if (!counter || !current || !beliefs.length || !('IntersectionObserver' in window)) return;
 counter.hidden = false;
 /* Only shown while a belief is under the middle of the screen, so it never floats over the
    opening narrative or the closing promise. */
 const visible = new Set();
 const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
   const n = entry.target.dataset.ethosBelief;
   if (entry.isIntersecting) {
    visible.add(n);
    current.textContent = n.padStart(2, '0');
   } else {
    visible.delete(n);
   }
  });
  counter.classList.toggle('is-on', visible.size > 0);
 }, {rootMargin: '-45% 0px -50% 0px'});
 beliefs.forEach(el => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["five-shades"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-five-shades]').forEach(root => {
 const chapters = [...root.querySelectorAll('[data-shade]')];
 const links = [...root.querySelectorAll('[data-shade-link]')];

 /* Shade bar: highlight the chapter under the middle of the screen and keep its chip in view. */
 if ('IntersectionObserver' in window) {
  const active = new IntersectionObserver(entries => {
   entries.filter(entry => entry.isIntersecting).forEach(entry => {
    links.forEach(link => {
     const on = link.dataset.shadeLink === entry.target.dataset.shade;
     link.toggleAttribute('aria-current', on);
     if (on) link.scrollIntoView({block: 'nearest', inline: 'center', behavior: 'auto'});
    });
   });
  }, {rootMargin: '-45% 0px -50% 0px'});
  chapters.forEach(chapter => active.observe(chapter));
  /* Hero and formula carry no shade, so reaching them clears the highlight. */
  root.querySelectorAll('.shades-hero, .shades-formula').forEach(el => active.observe(el));
 }

 /* Pairing links: shade names inside the copy ("Pair it with Dark Brown Nude") jump to that shade.
    Exact case only, so everyday words like "a rich nude" are left alone. Longest names first so "Nude" never wins inside "Light Nude". */
 const targets = chapters.map(chapter => ({name: chapter.dataset.shadeName, id: chapter.id})).filter(target => target.name).sort((a, b) => b.name.length - a.name.length);
 if (!targets.length) return;
 const escaped = targets.map(target => target.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
 const pattern = new RegExp('\\b(' + escaped.join('|') + ')\\b', 'g');
 chapters.forEach(chapter => {
  const walker = document.createTreeWalker(chapter.querySelector('.shades-copy'), NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(node => {
   if (node.parentElement.closest('a')) return;
   const text = node.nodeValue;
   pattern.lastIndex = 0;
   if (!pattern.test(text)) return;
   const fragment = document.createDocumentFragment();
   let cursor = 0;
   text.replace(pattern, (match, _name, offset) => {
    if (match === chapter.dataset.shadeName) return match;
    fragment.append(text.slice(cursor, offset));
    const link = document.createElement('a');
    link.className = 'shades-pair';
    link.href = '#' + targets.find(target => target.name === match).id;
    link.textContent = match;
    fragment.append(link);
    cursor = offset + match.length;
    return match;
   });
   fragment.append(text.slice(cursor));
   node.replaceWith(fragment);
  });
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shade-finder"]) return;
  try {
    
document.querySelectorAll('[data-shade-finder]').forEach(root => {
 const KEY = 'sbs-shade-finder-v1';
 const store = {
  read() { try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (_) { return {}; } },
  write(data) { try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (_) {} },
  clear() { try { sessionStorage.removeItem(KEY); } catch (_) {} }
 };

 const success = root.querySelector('[data-finder-success]');
 if (success) { store.clear(); success.focus(); return; }

 const form = root.querySelector('form');
 const steps = [...root.querySelectorAll('[data-step]')];
 if (!form || !steps.length) return;
 const back = root.querySelector('[data-finder-back]');
 const next = root.querySelector('[data-finder-next]');
 const send = root.querySelector('[data-finder-send]');
 const progress = root.querySelector('[data-finder-progress]');
 const saved = store.read();
 const savedAnswers = saved.answers || {};
 let index = 0;

 /* Restore answers after a refresh or a failed submit. */
 [...form.elements].forEach(field => {
  if (!field.name || !(field.name in savedAnswers)) return;
  if (field.type === 'radio') field.checked = field.value === savedAnswers[field.name];
  else if (field.type !== 'hidden') field.value = savedAnswers[field.name];
 });

 const answered = step => [...step.querySelectorAll('input[type=radio]')].some(radio => radio.checked) || [...step.querySelectorAll('textarea')].some(area => area.value.trim());

 function show(target, focus) {
  index = Math.max(0, Math.min(steps.length - 1, target));
  const last = index === steps.length - 1;
  steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
  back.hidden = index === 0;
  next.hidden = last;
  send.hidden = !last;
  next.textContent = answered(steps[index]) ? next.dataset.next : next.dataset.skip;
  next.classList.toggle('btn--primary', answered(steps[index]));
  next.classList.toggle('btn--secondary', !answered(steps[index]));
  progress.querySelector('progress').value = index + 1;
  progress.querySelector('[data-finder-current]').textContent = index + 1;
  save();
  if (focus) steps[index].querySelector('legend').focus({preventScroll: true});
  if (focus) progress.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
 }

 function save() {
  const answers = {};
  new FormData(form).forEach((value, name) => { if (name.startsWith('contact[') && typeof value === 'string') answers[name] = value; });
  store.write({answers, index});
 }

 root.classList.add('is-stepped');
 progress.hidden = false;
 back.addEventListener('click', () => show(index - 1, true));
 next.addEventListener('click', () => show(index + 1, true));
 form.addEventListener('input', () => show(index, false));
 /* Pointer taps on an answer move on by themselves. Keyboard arrows fire clicks with detail 0, so they never jump ahead. */
 form.addEventListener('click', event => {
  if (event.detail > 0 && event.target.matches('input[type=radio]')) setTimeout(() => show(index + 1, true), 220);
 });
 /* Enter inside an earlier step should move on, not send a half-finished form. */
 form.addEventListener('submit', event => {
  if (index < steps.length - 1) { event.preventDefault(); show(index + 1, true); return; }
  /* Shopify runs its spam check before the form posts; show that something is happening, and recover if it stalls. */
  send.classList.add('is-loading');
  setTimeout(() => send.classList.remove('is-loading'), 8000);
 });

 show(Number(saved.index) || 0, false);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shade-quiz"] && !Shopify.designMode) return;
  try {
    
/* Three answers, one vote each. Most votes wins; on a three-way tie the first answer decides. */
document.querySelectorAll('[data-shade-quiz]').forEach(root => {
 const form = root.querySelector('[data-quiz-form]');
 const steps = [...root.querySelectorAll('[data-quiz-step]')];
 const results = root.querySelector('[data-quiz-results]');
 const panels = [...root.querySelectorAll('[data-quiz-result]')];
 const back = root.querySelector('[data-quiz-back]');
 const bar = root.querySelector('[data-quiz-progress] progress');
 if (!form || steps.length !== 3 || !panels.length) return;

 /* Only now does the one-at-a-time layout apply; without JS all three questions stay readable. */
 root.classList.add('is-ready');
 let index = 0;

 const show = target => {
  index = Math.max(0, Math.min(steps.length - 1, target));
  steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
  back.hidden = index === 0;
  if (bar) bar.value = index + 1;
  steps[index].querySelector('.sbs-quiz__legend').focus();
 };

 const finish = () => {
  const votes = steps.map(step => step.querySelector('input:checked')).filter(Boolean).map(input => input.value);
  if (votes.length !== steps.length) return;
  const tally = {};
  votes.forEach(vote => { tally[vote] = (tally[vote] || 0) + 1; });
  /* Walking the votes in order and taking a strict improvement means the earliest answer holds a tie. */
  let winner = votes[0], best = 0;
  votes.forEach(vote => { if (tally[vote] > best) { best = tally[vote]; winner = vote; } });

  const panel = panels.find(p => p.dataset.quizResult === winner) || panels[0];
  panels.forEach(p => { p.hidden = p !== panel; });
  form.hidden = true;
  results.hidden = false;
  panel.focus();
 };

 root.addEventListener('change', event => {
  if (!event.target.matches('[data-quiz-option]')) return;
  /* A beat so the choice registers visually before the question changes. */
  setTimeout(() => { index < steps.length - 1 ? show(index + 1) : finish(); }, 240);
 });

 back.addEventListener('click', () => show(index - 1));

 root.addEventListener('click', event => {
  if (!event.target.closest('[data-quiz-restart]')) return;
  form.reset();
  results.hidden = true;
  panels.forEach(p => { p.hidden = true; });
  form.hidden = false;
  show(0);
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["share-story"] && !Shopify.designMode) return;
  try {
    
/* The old-combination box is open in the markup so it survives without JS. Here it is hidden until Yes,
   and cleared on No so a stale answer cannot be submitted. */
document.querySelectorAll('[data-share-story]').forEach(root => {
 const success = root.querySelector('[data-share-success]');
 if (success) { success.focus(); return; }

 const reveal = root.querySelector('[data-share-reveal]');
 const mix = root.querySelectorAll('input[name="contact[Used to mix]"]');
 if (!reveal || !mix.length) return;

 const yes = root.dataset.yes;
 root.classList.add('is-ready');

 const sync = () => {
  const chosen = [...mix].find(input => input.checked);
  const open = !!chosen && chosen.value === yes;
  reveal.classList.toggle('is-open', open);
  if (!open) reveal.querySelector('textarea').value = '';
 };

 mix.forEach(input => input.addEventListener('change', sync));
 sync();

 /* Steps. Only now are they separated: without JS both stay visible and the form is one long page. */
 const steps = [...root.querySelectorAll('[data-share-step]')];
 const dots = [...root.querySelectorAll('[data-share-progress] li')];
 const next = root.querySelector('[data-share-next]');
 const back = root.querySelector('[data-share-back]');
 const form = root.querySelector('form');
 if (steps.length === 2 && next && back && form) {
  root.classList.add('is-stepped');
  let step = 0;

  const show = (target, moveFocus) => {
   step = Math.max(0, Math.min(steps.length - 1, target));
   steps.forEach((s, i) => s.classList.toggle('is-active', i === step));
   dots.forEach((d, i) => d.classList.toggle('is-on', i <= step));
   back.hidden = step === 0;
   if (moveFocus) {
    steps[step].focus({ preventScroll: true });
    const top = root.querySelector('.sbs-share__progress');
    if (top) top.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
   }
  };

  next.addEventListener('click', () => show(1, true));
  back.addEventListener('click', () => show(0, true));

  /* Enter on step one advances instead of submitting a half-finished story. */
  form.addEventListener('submit', event => {
   if (step < steps.length - 1) { event.preventDefault(); show(1, true); }
  });

  show(0, false);
 }

 /* The photo posts to the form app, separately from the story. Copy the name and email the visitor has
    already given into that form so the two can be matched, and so the hidden fields are never empty. */
 const photo = root.querySelector('.sbs-share__photo');
 if (photo) {
  const pairs = [['#ShareName', 'name'], ['#ShareEmail', 'email']];
  const mirror = () => pairs.forEach(([from, to]) => {
   const src = root.querySelector(from);
   const dest = photo.querySelector('[name="' + to + '"]');
   if (src && dest && dest.value !== src.value) {
    dest.value = src.value;
    dest.dispatchEvent(new Event('input', { bubbles: true }));
   }
  });
  pairs.forEach(([from]) => root.querySelector(from)?.addEventListener('input', mirror));
  /* The app hydrates after us, so mirror again once its fields exist. */
  new MutationObserver(mirror).observe(photo, { childList: true, subtree: true });
  mirror();
 }

 /* Consent: the hidden "No" and the checkbox share a name, so a tick submits both values and the answer
    depends on the server keeping the last one. Rather than trust that, disable the hidden input while the
    box is ticked — a disabled field is not submitted, so exactly one value is ever sent. Without JS the
    pair still works by last-value, which is the conventional parse; this just removes the assumption for
    everyone who has JS. */
 root.querySelectorAll('.sbs-share__consents input[type="checkbox"]').forEach(box => {
  const hidden = root.querySelector('input[type="hidden"][name="' + box.name + '"]');
  if (!hidden) return;
  const pair = () => { hidden.disabled = box.checked; };
  box.addEventListener('change', pair);
  pair();
 });

 /* An error re-renders the form; send focus to the message so it is not missed. */
 const error = root.querySelector('.notice--error');
 if (error) error.focus();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-timeline"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-story]').forEach(root => {
 if (!('IntersectionObserver' in window)) return;
 const chapters = [...root.querySelectorAll('[data-story-chapter]')];
 const links = [...root.querySelectorAll('[data-story-link]')];

 /* Rail: which chapter is under the middle of the screen. */
 const active = new IntersectionObserver(entries => {
  entries.filter(entry => entry.isIntersecting).forEach(entry => {
   links.forEach(link => link.toggleAttribute('aria-current', link.dataset.storyLink === entry.target.dataset.storyChapter));
  });
 }, {rootMargin: '-45% 0px -50% 0px'});
 chapters.forEach(chapter => active.observe(chapter));

 /* On small screens the rail floats over the page, so it only shows while the story itself is on screen. */
 new IntersectionObserver(entries => root.classList.toggle('is-reading', entries[0].isIntersecting), {rootMargin: '-50% 0px -50% 0px'}).observe(root.querySelector('.story-body'));

 /* Rail fill: whole chapters passed plus the fraction of the current one, so the line reaches each dot as its chapter reaches mid-screen. */
 let ticking = false;
 const update = () => {
  ticking = false;
  const mid = innerHeight / 2;
  let progress = 0;
  chapters.forEach((chapter, i) => {
   const rect = chapter.getBoundingClientRect();
   if (rect.top <= mid) progress = (i + Math.min(1, (mid - rect.top) / rect.height)) / chapters.length;
  });
  root.style.setProperty('--story-progress', progress.toFixed(4));
 };
 addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, {passive: true});
 update();

 /* Motion is opt-out: visitors who ask for reduced motion keep the rail but get a still page. */
 if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

 /* Phones get a still hero. The reveals go away with the attribute; the hero's own keyframes cannot, because
    they hang off .story.is-animated and the chapters below the fold still need that class — so they are
    switched off in story-timeline.css instead. Mirrors the hero strip in assets/sbs-motion.js. */
 if (innerWidth <= 767) {
  root.querySelectorAll('.story-hero [data-story-reveal]').forEach(el => el.removeAttribute('data-story-reveal'));
 }

 root.classList.add('is-animated');

 /* Reveal on entry. Items that arrive together are staggered so a run of short lines lands like beats. */
 const reveal = new IntersectionObserver(entries => {
  entries.filter(entry => entry.isIntersecting).forEach((entry, i) => {
   entry.target.style.transitionDelay = Math.min(i, 6) * 90 + 'ms';
   entry.target.classList.add('is-in');
   reveal.unobserve(entry.target);
  });
 }, {rootMargin: '0px 0px -12% 0px', threshold: 0.1});
 root.querySelectorAll('[data-story-reveal]').forEach(el => reveal.observe(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-header"]) return;
  try {
    
/* Close a header disclosure on Escape or on an outside click; hover opening is CSS-free and lives in the markup. */
document.addEventListener('keydown', event => {
 if (event.key !== 'Escape') return;
 document.querySelectorAll('[data-header-panel][open]').forEach(panel => { panel.open = false; panel.querySelector('summary').focus(); });
});
document.addEventListener('click', event => {
 document.querySelectorAll('[data-header-panel][open]').forEach(panel => { if (!panel.contains(event.target)) panel.open = false; });
});

  } catch(e) { console.error(e); }
})();
})();
